// [v2-orch] log helpers.
//
// Filter every line emitted by the orchestrator-routing FE wiring with the
// literal substring "[v2-orch]". Match against Lambda CloudWatch "[orch]" lines
// by `traceId` (same per-turn 8-char hex / uuid).
//
// Logs here are the verification layer — they describe every step a turn
// passes through (derive → ws.send → frame.recv → buffer → finalize →
// history.save). Missing/wrong lines map to exact failure modes. Do not
// strip after the feature stabilizes.

type LogPayload = Record<string, unknown>;

function format(payload: LogPayload): string {
  try {
    return JSON.stringify(payload);
  } catch {
    return "[unserializable]";
  }
}

export function v2orch(step: string, payload: LogPayload = {}): void {
  // eslint-disable-next-line no-console
  console.log(`[v2-orch] ${step}`, format(payload));
}

export function v2orchErr(step: string, payload: LogPayload = {}): void {
  // eslint-disable-next-line no-console
  console.error(`[v2-orch][err] ${step}`, format(payload));
}
